import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { taskHandler, keyEmptyCheck } from 'aurora-utils/utils';
import messages from 'aurora-translations';

import styles from './styleJss';

function notification({ classes, task, applicationType, applicationId }) {
  return (
    <>
      {task?.type !== 'NOTIFICATION' &&
        applicationType === task?.applicationType &&
        applicationId?.toString() === task?.applicationId?.toString() && (
          <div className={classes.notificationArea}>
            <div className={classes.notificationbar}>
              <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32ZM14.56 9.30137C12.0757 9.94049 10.24 12.1948 10.24 14.8798V18.7194C10.24 19.0732 9.95256 19.36 9.60067 19.36C8.89337 19.36 8.32 19.9345 8.32 20.64C8.32 21.3469 8.8941 21.92 9.60317 21.92H22.3968C23.1055 21.92 23.68 21.3455 23.68 20.64C23.68 19.9331 23.1039 19.36 22.3993 19.36C22.0462 19.36 21.76 19.0754 21.76 18.7194V14.8798C21.76 12.1959 19.9247 9.94071 17.44 9.3014V8.64027C17.44 7.84296 16.7953 7.2 16 7.2C15.2063 7.2 14.56 7.84483 14.56 8.64027V9.30137ZM13.76 22.56C13.76 23.7971 14.7629 24.8 16 24.8C17.2371 24.8 18.24 23.7971 18.24 22.56H13.76Z'
                  fill='#0088FF'
                />
                <defs>
                  <linearGradient id='paint0_linear' x1='16' y1='0' x2='16' y2='32' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#FB7C90' />
                    <stop offset='1' stopColor='#CE1834' />
                  </linearGradient>
                </defs>
              </svg>
              <Typography variant='body1'>
                <FormattedMessage {...messages.you_have_a_pending_task} />
              </Typography>
            </div>
            <Typography variant='body1'>{keyEmptyCheck(task?.type)}</Typography>
            <Button
              className={classes.adgmRedBtn}
              onClick={() => {
                taskHandler(task);
              }}
            >
              {task?.type === 'GET_CERTIFICATE' ? (
                <FormattedMessage {...messages.download_certificate} />
              ) : (
                <FormattedMessage {...messages.review_contract} />
              )}
            </Button>
          </div>
        )}
    </>
  );
}

notification.propTypes = {
  classes: PropTypes.object.isRequired,
  task: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  applicationType: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
};

export default withStyles(styles)(notification);
